import React from 'react';
import { Navigation } from '../../../global-functions';
import { ICartItemInfo } from '../../../models/pro-sites';
import Modal, { IModalChildProps } from '../../common/modal';
import { HEARING_AIDS_URL_PARAMS } from '../../../models/constants';
import { Link } from 'react-router-dom';
import { WrappedComponentProps, injectIntl, useIntl } from 'react-intl';

interface IMessageModal extends IModalChildProps {
    cartItems: ICartItemInfo[];
}

const MessageModal = ({ cartItems }: IMessageModal) => {
    const intl = useIntl();
    return (
        <Modal>
            <div className="modal-content">
                <div className="modal-header">
                    <h4 className="modal-title font-green">
                        <span className="fad fa-check" />
                        {intl.formatMessage({
                            id: 'Added_to_Cart',
                            defaultMessage: 'Added to Cart',
                        })}
                    </h4>
                </div>
                <div className="modal-header">
                    {cartItems.map((item, i) => {
                        return (
                            i <= 5 && (
                                <div className="row" key={item.lineItemID + i}>
                                    <div className="col-sm-12">
                                        <div className="col-sm-3">
                                            <button
                                                className="btn-link"
                                                onClick={() =>
                                                    Navigation.pushExternal(
                                                        item.url
                                                    )
                                                }
                                            >
                                                <img
                                                    src={item.imageUrl}
                                                    style={{
                                                        height: '100px',
                                                    }}
                                                    alt={item.description}
                                                />
                                            </button>
                                        </div>
                                        <div className="col-sm-9">
                                            <p>
                                                {' '}
                                                <button
                                                    className="btn-link"
                                                    onClick={() =>
                                                        Navigation.pushExternal(
                                                            item.url
                                                        )
                                                    }
                                                >
                                                    {item.description}
                                                </button>
                                            </p>
                                            {item.orderType && (
                                                <p>{item.orderType}</p>
                                            )}
                                            {item.quantity && (
                                                <p>
                                                    {intl.formatMessage({
                                                        id: 'Quantity',
                                                        defaultMessage:
                                                            'Quantity',
                                                    })}
                                                    {': '}
                                                    {item.quantity}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )
                        );
                    })}
                </div>
                <div className="modal-footer">
                    <Link
                        id="view-cart-btn"
                        to={'/estore/cart'}
                        className="btn btn-default pull-left"
                    >
                        {intl.formatMessage({
                            id: 'View_Cart',
                            defaultMessage: 'View Cart',
                        })}
                    </Link>
                    <span className="pull-right">
                        <Link
                            id="continue-shopping-btn"
                            to={
                                '/estore/product-list?' +
                                HEARING_AIDS_URL_PARAMS
                            }
                            className="btn btn-default"
                        >
                            {intl.formatMessage({
                                id: 'Continue_Shopping',
                                defaultMessage: 'Continue Shopping',
                            })}
                        </Link>
                        <button
                            id="proceed-to-checkout-btn"
                            className="btn btn-info"
                            onClick={() => {
                                Navigation.pushExternal('/estore/checkout');
                            }}
                        >
                            {intl.formatMessage({
                                id: 'Proceed_to_Checkout',
                                defaultMessage: 'Proceed to Checkout',
                            })}
                        </button>
                    </span>
                </div>
            </div>
        </Modal>
    );
};

export default MessageModal;
